import axiosInstance from '../../../../config/axiosInstance';
const  ImportTableService = {
    async GetAllImportTable(redirectCallback) {
        try {            
            const response = await axiosInstance.get(`/Setup/GetImportTables`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllImportFields(redirectCallback,TableID) {
        try {            
            const response = await axiosInstance.get(`/Setup/GetImportFields?TableID=${TableID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default ImportTableService;